import { Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { UsersList } from '@verantos-dev/feature-users-list';

const APP_ID = EvidencePlatformSidebarAppID.users;

export const UsersUiRoutes = () => {
  useAppId(APP_ID);
  return (
    <Routes>
      <Route index element={<UsersList />} />
    </Routes>
  );
};

export default withAuth(UsersUiRoutes, APP_ID);
